import { gql } from 'apollo-client-ppc';

export const fetchNativeCatalogProductDetails = gql`
  query fetchNativeCatalogProductDetails(
    $pageParams: ProductPageParams
    $searchText: String
    $id: ID
    $includeExperimentalProducts: Boolean
    $isAddOnsSearchEnabled: Boolean
    $filterOptions: [FilterOption]
    $isStatuspageEnabled: Boolean
    $isTeamWorkCollectionEnabled: Boolean
    $isStrategyCollectionEnabled: Boolean
    $isBitbucketProductEnabled: Boolean
  ) {
    nativeCatalog: partnerNativeCatalog(
      pageParams: $pageParams
      searchText: $searchText
      includeExperimentalProducts: $includeExperimentalProducts
      isAddOnsSearchEnabled: $isAddOnsSearchEnabled
      filterOptions: $filterOptions
      id: $id
      isStatuspageEnabled: $isStatuspageEnabled
      isTeamWorkCollectionEnabled: $isTeamWorkCollectionEnabled
      isStrategyCollectionEnabled: $isStrategyCollectionEnabled
      isBitbucketProductEnabled: $isBitbucketProductEnabled
    ) {
      nodes {
        id
        name
        vendorName
        productFamily
        productType
        baseProduct
        isApp
        isEnabledForOrder
        logoId
        url
        currency
        hasOptedInForPartnerPromotion
      }
      totalCount
    }
  }
`;
